import { george, observer, pr, React, RouteComponentProps, theme, ui } from "aaa";
import { IS_MASTER } from "config";
import { pushRoute } from "stores/RouterFunctions";
import { isMicroChip } from "types/card";
import { ActivateCardStore } from "./ActivateCardStore";

type IProps = RouteComponentProps<{}> & {
    store: ActivateCardStore
};

@observer
export class ActivateCardLandingPage extends React.Component<IProps, {}> {
    componentDidMount() {
        window.scrollTo(0, 0);
    }

    onSubmit = async () => {
        try {
            await this.props.store.activateCard();
            pushRoute("/activate-card/signing");
        } catch (error) {
            pushRoute("/error");
        }
    }

    render() {
        const TEST = !IS_MASTER && false;

        const microImage = require("../../assets/banner_micro.png");
        const stickerImage = require("../../assets/banner_sticker.png");

        const image = this.props.store.cardStore.card
            ? (isMicroChip(this.props.store.cardStore.card) ? microImage : stickerImage)
            : (TEST ? microImage : null);
        const buttonIsLoading = this.props.store.isLoading || this.props.store.isLoadingActivation;

        return (
            <george.LandingBackground>
                <george.PageWithActionButton>
                    {(!this.props.store.isLoading || TEST) &&
                        <div>
                            {((this.props.store.cardStore.card && image) || TEST) &&
                                <img
                                    src={image}
                                    style={{ width: "100%" }}
                                    alt=""
                                />
                            }

                            <div style={{ padding: 15, paddingTop: 20, paddingBottom: 2 * theme.ACTION_BUTTON_HEIGHT }}>
                                <div style={{ textAlign: "center" }}>
                                    <pr.LandingPageTitle>{ui.__("activateCard.document.title")}</pr.LandingPageTitle>
                                </div>
                                <div style={{ textAlign: "left" }}>
                                    <br />
                                    <pr.P_14_CONTENT>
                                        {ui.__("activateCard.info", {
                                            product: this.props.store.cardStore.card ?
                                                this.props.store.cardStore.card.productI18N : ui.__("common.bankCard")
                                        })}
                                    </pr.P_14_CONTENT>
                                </div>
                            </div>
                        </div>
                    }

                    <george.LoadingIndicator isLoading={this.props.store.isLoading} height={ui.windowHeight} />
                    <george.ActionButton
                        messageId="button.continue"
                        disableButton={buttonIsLoading}
                        isLoading={buttonIsLoading}
                        onClick={this.onSubmit}
                    />
                </george.PageWithActionButton>
            </george.LandingBackground>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/activateCard/ActivateCardLandingPage.tsx